<template>
  <div>
    <header class="l-header">
      <div class="inner">
        <div class="logo">
          <template v-if="!isSupple">
            <a tabindex="1"><img src="@/assets/img/common/logo-set.svg" alt="労務監査クラウド ヨクスル"></a>
          </template>
          <template v-else>
            <a tabindex="1"><img src="@/assets/img/common/logo-roumu-set.svg" alt="労務監査クラウド 労務サプリ"></a>
          </template>
        </div>
      </div>
    </header>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSupple: false,
    }
  },
  created() {
    this.isSupple = Object.keys(this.$route.query).includes('supple');
  },
  destroyed() {
    this.$store.dispatch('contactForm/init');
  }
}
</script>
